import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Radio,
  Select,
  Alert,
  notification,
  Typography,
  Divider,
  Spin,
  Empty,
} from "antd";
import Axios from "axios";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  useNavigate,
  useParams,
  useLocation,
} from "react-router-dom";
import {
  HomeTwoTone,
  SettingTwoTone,
  SmileOutlined,
  SyncOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SmileTwoTone,
} from "@ant-design/icons";
import {
  environmentVariable,
  environment,
  apiRoutes,
} from "../../auth/apiRoute";
import AdminLayout from "../../layout/adminLayout";

export default function ViewNomination(props) {
  const { Title, Paragraph, Text } = Typography;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedHotel, setSelectedHotel] = useState();
  const [currentNomination, setCurrentNomination] = useState({});
  let { nominationId } = useParams();

  const [hotels, setHotels] = useState([]);
  const categories = [
    "Full-Time Hourly With Guest Contact",
    "Full-Time Hourly Without Guest Contact",
    "Full-Time Room Attendant",
    "Managerial Below General Manager",
  ];
  const questions = [
    "1. Describe the employee’s overall job performance and dedication to his/her profession and to your Hotel. Please be specific and cite at least one example.",
    "2.  Describe the interaction of the employee with his/her coworkers and/or with guests. Please cite specific examples of the employee’s positive impact on the guest experience at your hotel. ",

    "3. Please list any awards or recognition that the employee has received from the Hotel, management, guests, award organizations and/or peers.",
    "4. Please list any other reasons for nominating this employee for the Big Apple Stars Awards.",
  ];

  useEffect(() => {
    // getUser();

    getNominationById(nominationId);
  }, []);

  const getNominationById = async (nominationId) => {
    setLoading(true);
    try {
      const response = await Axios.post(apiRoutes[environment].getnomination, {
        nominationId: nominationId,
      });
      setLoading(false);
      if (response.status == 200) {
        setCurrentNomination(response.data);

        setHotels([response.data.hotel]);

        setSelectedHotel(response.data.hotel);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }

    setLoading(false);
  };

  const questionsAndAnswers = () => {
    return questions.map((question, index) => {
      return (
        <Paragraph key={index + "q"}>
          <Text>{question}</Text>
          <Paragraph className="admin-view-nomination-answer">
            {currentNomination["q" + (index + 1)] &&
            currentNomination["q" + (index + 1)].answer ? (
              <p className="display-linebreak">
                {" "}
                {currentNomination["q" + (index + 1)].answer}
              </p>
            ) : (
              <Empty description={"No response"} />
            )}
          </Paragraph>
        </Paragraph>
      );
    });
  };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully updated! ",
      placement: "top",
    });
  };

  const footer = () => {
    if (state && state.nominations) {
      var nominations = state.nominations;
      var total = state.nominations.length;
      const index = state.nominations.findIndex((item) => item == nominationId);
      return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button disabled={index == 0}>
            <Link
              to={`/admin/nominations/` + state.nominations[index - 1]}
              state={{ nominations }}
            >
              Previous
            </Link>
          </Button>
          <div>
            <Text>
              {index + 1} / {total}
            </Text>
          </div>
          <Button disabled={index == total - 1}>
            <Link
              to={`/admin/nominations/` + state.nominations[index + 1]}
              state={{ nominations }}
            >
              Next
            </Link>
          </Button>
        </div>
      );
    }
  };
  return (
    <Spin spinning={loading}>
      <div>
        <>
          <Button onClick={() => navigate(-1)}>
            <ArrowLeftOutlined />
            go back
          </Button>
        </>
        <Title level={2}>
          {currentNomination.firstName} {currentNomination.lastName}
        </Title>
        <Paragraph>
          <ul>
            <HomeTwoTone />
            From:{" "}
            <Text strong>
              {" "}
              {currentNomination.hotel ? currentNomination.hotel.name : ""}{" "}
            </Text>
            <SettingTwoTone /> For:{" "}
            <Text strong>
              {currentNomination.category ? currentNomination.category : ""}{" "}
            </Text>
            <SmileTwoTone /> By:{" "}
            <Text strong>
              {currentNomination.user && currentNomination.user.firstName
                ? currentNomination.user.firstName
                : ""}{" "}
              {currentNomination.user && currentNomination.user.lastName
                ? currentNomination.user.lastName
                : ""}
            </Text>
          </ul>
        </Paragraph>
        {questionsAndAnswers()}
      </div>

      {/* {footer()} */}
    </Spin>
  );
}
